import jwt from 'jsonwebtoken';
import store from '../store';

// all methods that connected with access + refresh pair
export default {
  checkAccessExpire() {
    // get access token form redux store
    const access = store.getters['auth/access'];
    // decode (not verify just decode) jwt access
    // and get expire date from it in timestamp seconds

    const { exp } = jwt.decode(access);
    // boundary timestamp, get current timestamp in seconds minus a minute
    const boundaryTimestamp = (Date.now() / 1000) + 60;
    // (send true) check if token is expired or will be expired in less than a minute
    return exp < boundaryTimestamp;
  },
};
